import { ref } from 'vue'

// Global toast state
const toastState = ref({
  show: false,
  message: '',
  color: 'primary',
  timeout: 5000
})

export function useToast() {
  const showToast = (message, options = {}) => {
    toastState.value = {
      show: true,
      message,
      color: options.color || 'primary',
      timeout: options.timeout || 5000
    }
  }

  const success = (message, options = {}) => {
    showToast(message, { ...options, color: 'success' })
  }

  const error = (message, options = {}) => {
    showToast(message, { ...options, color: 'error' })
  }

  const warning = (message, options = {}) => {
    showToast(message, { ...options, color: 'warning' })
  }

  const info = (message, options = {}) => {
    showToast(message, { ...options, color: 'info' })
  }

  const hideToast = () => {
    toastState.value.show = false
  }

  return {
    toastState,
    showToast,
    success,
    error,
    warning,
    info,
    hideToast
  }
}